import { Box } from "@mui/material"
import { type FC, useMemo } from "react"
import { useFormContext } from "react-hook-form"

import { GoodsReceiptDetailsTotals, PurchaseOrderAddAlert, SoftReceivedPurchaseOrderForm } from "../../../components"
import { useGoodsReceiptContext } from "../../../contexts"
import type { SoftReceivedPurchaseOrdersFormValues } from "../../../schemas"
import { calculateSoftReceivedPurchaseOrderFormTotals } from "../../../utils"

export const SoftReceivedPurchaseOrdersTab: FC = () => {
  const { goodsReceipt, onAddPurchaseOrder, onRemovePurchaseOrder, isResettingRef } = useGoodsReceiptContext()
  const { watch } = useFormContext<SoftReceivedPurchaseOrdersFormValues>()

  const purchaseOrders = goodsReceipt.orders ?? []
  const goodsReceiptLines = goodsReceipt.productDetails ?? []
  const formValues = watch()

  const totals = useMemo(() => {
    const lineFormValues = formValues.purchaseOrders.flatMap((purchaseOrder) => purchaseOrder.lines)
    return calculateSoftReceivedPurchaseOrderFormTotals(lineFormValues)
  }, [formValues])

  if (!purchaseOrders.length && onAddPurchaseOrder) {
    return <PurchaseOrderAddAlert onAdd={onAddPurchaseOrder} />
  }

  return (
    <Box className='flex min-h-0 grow flex-col gap-y-8 overflow-auto' data-testid='goods-receipt-purchase-orders'>
      <Box className='flex flex-col gap-y-4'>
        {purchaseOrders.map((purchaseOrder, purchaseOrderIndex) => (
          <SoftReceivedPurchaseOrderForm
            key={purchaseOrder.orderId}
            purchaseOrder={purchaseOrder}
            purchaseOrderIndex={purchaseOrderIndex}
            goodsReceiptLines={goodsReceiptLines}
            isResettingRef={isResettingRef}
            onRemove={onRemovePurchaseOrder}
          />
        ))}
      </Box>
      <GoodsReceiptDetailsTotals label='Total Received' totals={totals} data-testid='total-received' />
    </Box>
  )
}
